import Informe from './Informe';

export default Informe;
